export default __webpack_public_path__ + "static/box_3-d7c5d55286e94037db97a6ed2ecae6b6.png";